<svg class="icon" [ngClass]="[size ? 'icon-size-em--' + size : '', classes]" [attr.aria-label]="alt" role="img"
	[attr.alt]="alt" [attr.title]="alt">
	<use xmlns:xlink="http://www.w3.org/1999/xlink" [attr.xlink:href]="'./assets/images/'+svg"></use>
</svg>
